import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const consent = localStorage.getItem('sj-cookie-consent');
    if (!consent) {
      // Small delay so it doesn't pop up immediately on load
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem('sj-cookie-consent', 'accepted');
    setIsVisible(false);
  };
  const handleReject = () => {
    localStorage.setItem('sj-cookie-consent', 'rejected');
    setIsVisible(false);
  };
  return <AnimatePresence data-id="element-63">
      {isVisible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 200
    }} className="fixed bottom-0 left-0 right-0 z-[100] bg-primary border-t border-white/10 shadow-2xl" data-id="element-64">
          <div className="container mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-65">
            <div className="text-white/80 text-sm leading-relaxed max-w-3xl" data-id="element-66">
              <p data-id="element-67">
                We use cookies to enhance your experience, analyze site traffic,
                and serve tailored content. By continuing to visit this site you
                agree to our use of cookies.{' '}
                <a href="#" className="text-accent hover:underline font-medium" data-id="element-68">
                  Read our Privacy Policy
                </a>
                .
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 w-full md:w-auto shrink-0" data-id="element-69">
              <button onClick={handleReject} className="w-full sm:w-auto px-6 py-2.5 rounded-lg border border-white/20 text-white text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-70">
                Reject non-essential
              </button>
              <button onClick={handleAccept} className="w-full sm:w-auto px-6 py-2.5 rounded-lg bg-accent text-white text-sm font-bold hover:bg-accent/90 transition-colors shadow-lg shadow-accent/20" data-id="element-71">
                Accept all
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}